/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFEnumerationCounter
 */
export interface CRSFEnumerationCounter {
    /**
     * 
     * @type {number}
     * @memberof CRSFEnumerationCounter
     */
    ips: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFEnumerationCounter
     */
    subdomains: number;
}

/**
 * Check if a given object implements the CRSFEnumerationCounter interface.
 */
export function instanceOfCRSFEnumerationCounter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ips" in value;
    isInstance = isInstance && "subdomains" in value;

    return isInstance;
}

export function CRSFEnumerationCounterFromJSON(json: any): CRSFEnumerationCounter {
    return CRSFEnumerationCounterFromJSONTyped(json, false);
}

export function CRSFEnumerationCounterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFEnumerationCounter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ips': json['ips'],
        'subdomains': json['subdomains'],
    };
}

export function CRSFEnumerationCounterToJSON(value?: CRSFEnumerationCounter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ips': value.ips,
        'subdomains': value.subdomains,
    };
}

